module.exports = __webpack_public_path__ + "static-portal/img/show.b8c8baf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/show.gif
// module id = yADl
// module chunks = 4